// extracted by mini-css-extract-plugin
module.exports = {"item-text":"about_item-text__tI9eb"};